import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';

export function useGetTrafficForecastGq(command: CommandGq) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getTrafficForecast,
  };
}

const gqTag = gql`
  query GetTrafficForecast($command: GetTrafficForecastCommand!) {
    projects {
      getTrafficForecast(command: $command) {
        lastYearData {
          month
          year
          volume
          traffic
        },
        baselineCtr,
        targetCtr,
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getTrafficForecast: ResponseGq;
  };
}

export interface ResponseGq {
  lastYearData: MonthDataGq[];
  baselineCtr: number;
  targetCtr: number;
}

export interface MonthDataGq {
  month: number;
  year: number;
  volume: number;
  traffic: number;
}

export interface Variables {
  command: CommandGq;
}
export interface CommandGq {
  projectId: number;
  tagGroupId: number;
  tagId: number;
  rankValues: number[];
}
